import {useNavigate} from 'react-router-dom';
export const HomeStatsB = (props) => {
    const navigate = useNavigate();

  const allSubjectOptions = [
    {
      name:'重要讲话',
      description:'习总书记讲话报告',
      // bg:'https://img1.baidu.com/it/u=4267434241,3835685484&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=450'
      bg:require('@images/subjects/subject1.jpg'),
    },
    {
      name:'新型电力系统',
      description:'能源电力领域前沿政策',
      // bg:'https://bj-expert-center.oss-cn-beijing.aliyuncs.com/policy/subject-image/3uEyttOaQWGiPikUeriHXn.png'
      bg:require('@images/subjects/subject2.png'),
    },
    {
      name:'双碳',
      description:'碳达标、碳中和政策动态',
      // bg:'https://bj-expert-center.oss-cn-beijing.aliyuncs.com/policy/subject-image/0yN5LnLdWUkgWUZ4Lyn3fm.png'
      bg:require('@images/subjects/subject4.png'),
    },
    {
      name:'能源前沿科技',
      description:'大模型等前沿科技进展',
      // bg:'https://bj-expert-center.oss-cn-beijing.aliyuncs.com/policy/subject-image/3pBo0tQJhBN2Wu0nHslYm8.png'
      bg:require('@images/subjects/subject3.png'),
    },
    {
      name:'国际贸易',
      description:'国际贸易政策动态',
      // bg:'https://bj-expert-center.oss-cn-beijing.aliyuncs.com/policy/subject-image/0yN5LnLdWUkgWUZ4Lyn3fm.png'
      bg:require('@images/subjects/subject5.png'),
    },
    {
      name:'大湾区',
      description:'大湾区相关政策',
      // bg:'https://bj-expert-center.oss-cn-beijing.aliyuncs.com/policy/subject-image/3pBo0tQJhBN2Wu0nHslYm8.png'
      bg:require('@images/subjects/subject6.png'),
    },
  ]

  // b环境显示全部专题
  const subjectOptions = allSubjectOptions

    return (
       <div className='md:w-[20%] bg-base-200 h-full py-4 pl-3 flex flex-col gap-6 md:ml-auto'>
  
                       <div className="card bg-base-100 w-full shadow-lg">
                <div className="card-body">
                    <h2 className="card-title text-primary">政策专题</h2>
                    <div class="grid grid-cols-1 gap-4 mt-4">
                      {
                        subjectOptions?.map(item=>(
                        <div class="card bg-base-100 shadow-xl">
                          <div className="card bg-base-100 image-full w-full shadow-xl">
                            <figure className="h-48">
                                <img
                                className="w-full h-full object-cover"
                                src={item.bg}
                                alt="" />
                            </figure>
                            <div className="card-body">
                                <h2 className="card-title">{item?.name}</h2>
                                <p>{item?.description}</p>
                                <div className="card-actions justify-end">
                                <button className="btn"
                                onClick={()=>{
                                  navigate(`/policy/subject?name=${encodeURIComponent(item?.name)}`)
                                }}
                                >进入专题</button>
                                </div>
                            </div>
                          </div>
                        </div>
                        ))
                      }
                    </div>
                </div>


            </div>
        </div>

    )
}